import { authenticatedFetch } from '../authenticatedFetch';
import { isHostRdr } from '../urls';
import { getEntitlements } from './entitlements';
import get from 'lodash/get';

let countriesIndustriesPromise;

export function getCountriesIndustriesFacets() {
  return countriesIndustriesPromise;
}

export function refetchCountriesIndustriesFacets() {
  return (countriesIndustriesPromise = getEntitlements().then(
    (entitlements) => {
      let endpoint = isHostRdr()
        ? '/fc/facets/countriesIndustries'
        : '/facets/countriesIndustries';
      const queryParams = [];
      const features = get(entitlements, 'features.features', []);
      if (features.includes('country_risk_and_industry_research_beta')) {
        queryParams.push('crirbeta=true');
      }
      if (queryParams.length > 0) {
        endpoint += `?${queryParams.join('&')}`;
      }
      return authenticatedFetch(endpoint).then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(
            `Facets Request responded with HTTP status ${response.status}`
          );
        }
      });
    }
  ));
}
